import React from "react";

interface PreviewImageProps {
  imagePreviewPath: string | undefined;
  children: React.ReactNode;
}

const PreviewImage: React.FC<PreviewImageProps> = ({
  imagePreviewPath,
  children
}) => (
  <div className="sample-preview__image-container">
    {imagePreviewPath ? (
      <img
        src={imagePreviewPath}
        data-testid={"sample_preview_image_container"}
      />
    ) : (
      <>
        {children}
        <img
          src={`${window.tcbase.urls.static}images/view-image-placeholder.png`}
        />
      </>
    )}
  </div>
);

export default PreviewImage;
